import React, { Component } from 'react';
import { View, Text, Image, Pressable, StyleSheet, Dimensions, Platform } from 'react-native';

import { COLOR, FONT, FONT_SIZE } from '../../constants/styles';
import OPComponent from '../components/op_component';
import Navigation from '../../navigation';
import GestureRecognizer from '../components/gesture_recognizer';

const GESTURE_CONFIG = {
  velocityThreshold: 0.3,
  directionalOffsetThreshold: 40,
};

export default class NotificationPopup extends OPComponent {
  constructor(props) {
    super(props);

    this._autoCloseTimeoutId = null;
  }

  componentDidMount() {
    if (this.props.autoDismissTimerSec) {
      this._autoCloseTimeoutId = setTimeout(this.close, this.props.autoDismissTimerSec * 1000);
    }
  }

  close = () => {
    if (this._autoCloseTimeoutId) {
      clearTimeout(this._autoCloseTimeoutId);
      this._autoCloseTimeoutId = null;
    }
    Navigation.dismissInAppNotification(this.props.componentId);
  };

  handlePress = () => {
    this.close();
    this.props.handlePress();
  };

  renderContents() {
    let { notification } = this.props;
    if (!notification) return null;
    // notification = {
    //   body:
    //     'Lorien changed Hlkjhljjjj in case Case Numba 1 to Oct 25, 2018, 4:00 PM PDT',
    //   title: 'Lorien changed an event on Case Numba 1',
    // };

    return (
      <Pressable style={styles.button} onPress={this.handlePress}>
        <Image
          style={styles.iconImage}
          source={require('../../../resources/notification-icon-alert.png')}
        />
        <View style={styles.textContainer}>
          {!!notification.title && !!notification.body && (
            <Text numberOfLines={1} style={styles.titleText}>
              {notification.title}
            </Text>
          )}
          <Text numberOfLines={3} style={styles.bodyText}>
            {notification.body || notification.title}
          </Text>
        </View>
      </Pressable>
    );
  }

  render() {
    let { height, width } = Dimensions.get('window');
    return (
      <View style={[styles.container, { width }]}>
        <GestureRecognizer onSwipeUp={this.close} style={{ flex: 1 }} config={GESTURE_CONFIG}>
          {this.renderContents()}
        </GestureRecognizer>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    height: 130,
    paddingTop: Platform.OS === 'ios' ? 20 : 0,
    backgroundColor: COLOR.contrast,
    borderBottomWidth: 1,
    borderColor: COLOR.accent,
  },
  button: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 25,
  },
  iconImage: {
    width: 24,
    height: 23,
    tintColor: COLOR.emphasis,
  },
  textContainer: {
    flex: 1,
    paddingLeft: 20,
  },
  titleText: {
    ...FONT.medium,
    fontSize: FONT_SIZE.small,
    color: COLOR.text,
    marginBottom: 10,
  },
  bodyText: {
    ...FONT.medium,
    fontSize: FONT_SIZE.regular,
    color: COLOR.text,
  },
});
